import { UrlUtils } from '.'

const AppUtils = {
    isStaging: () => process.env.NODE_ENV === 'staging',

    isIframe: (queryString) => {
        const { iframe } = UrlUtils.parseQueryString(queryString)
        return iframe === '1'
    },
}

export default AppUtils
